import React, { useEffect } from "react";
import Loader from "../../components/loader";
import PieceListSearchBar from "../../components/piece/pieceListWithSearchBar";
import { useDashboardContext } from "../../context/dashboardContext";
import { PieceResponseDTOMin } from "../../openapi-generated-client";

export default function DashboardBookmarkedPiecesPage() {

    const {appContext, sessionId} = useDashboardContext();
    const {bookmarkController} = appContext;

    const [data, setData] = React.useState<PieceResponseDTOMin[]|undefined>(undefined);

    async function fetchData() {
        try {
            setData((await bookmarkController.getBookmarkedPieces(sessionId)).data);
        } catch(error: any) {
            window.location.href = "/error/1";
        }
    }

    useEffect(() => {
        fetchData();
    }, []);


    if(data == undefined) return <Loader/>;

    return <PieceListSearchBar displayProps={{
        linkPrefix: "/pieces",
        hideComposer: true,
        hideIconDisplay: true,
        hideInfos: true,
        hideInstrumentation: true
    }} pieces={data || []}/>;
}